
export default {
  props: ["item", "horizontal"],
  data(){
    return{
      show:false
    }
  },
  mounted() {
    if (
      this.$hyperItem.categoryCheck(this.item)
    ) {
      this.show = true;
    }
  },
};
